// extracted by mini-css-extract-plugin
export default {"nameStepContainer":"Name_nameStepContainer__oayZi","headline":"Name_headline__YKJJB","email":"Name_email__jsbOl","forms":"Name_forms__OSOk6"};